import { api } from '../../lib/api';

export const RECIPE_TYPES = [
  { value: 'Preparation', label: 'Preparation / sub-recipe' },
  { value: 'MenuItem', label: 'Menu item' },
];

export const RECIPE_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Active', label: 'Active', tone: 'success' },
  { value: 'Archived', label: 'Archived', tone: 'warning' },
];

export const recipeTypeLabel = (t) => RECIPE_TYPES.find((x) => x.value === t)?.label || t;
export const recipeStatusMeta = (s) =>
  RECIPE_STATUSES.find((x) => x.value === s) || { value: s, label: s, tone: 'neutral' };

function toQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const recipesApi = {
  list: (params = {}) => api.get(`/recipes${toQuery(params)}`),
  get: (id) => api.get(`/recipes/${id}`),
  create: (payload) => api.post('/recipes', payload),
  update: (id, payload) => api.put(`/recipes/${id}`, payload),
  changeStatus: (id, status) => api.post(`/recipes/${id}/status`, { status }),
  remove: (id) => api.del(`/recipes/${id}`),
};

export const recipeCategoriesApi = {
  list: () => api.get('/recipe-categories'),
  create: (payload) => api.post('/recipe-categories', payload),
  update: (id, payload) => api.putWithId(`/recipe-categories/${id}`, id, payload),
  remove: (id) => api.del(`/recipe-categories/${id}`),
};
